module.exports = __webpack_public_path__ + "static/media/cup_icon.bf8b8596.png";